import { render, staticRenderFns } from "./CustomerFleet.vue?vue&type=template&id=1368f8a2&"
import script from "./CustomerFleet.vue?vue&type=script&lang=js&"
export * from "./CustomerFleet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports